<template>
  <div class="audiences">
    <confirm ref="confirm"></confirm>
    <v-progress-linear
      v-show="progressBar"
      slot="progress"
      color="blue"
      indeterminate
    />

    <v-container class="my-1">
      <v-layout row Wrap>
        <v-flex xs12 sm12 lg12
          ><v-card-text
            v-text="PageTitle"
            class="subtitle-1 grey--text"
          ></v-card-text>
        </v-flex>
      </v-layout>

      <v-data-table
        :hide-default-footer="true"
        :disable-pagination="true"
        :disable-sort="true"
        :disable-filtering="true"
        :items="audiences"
        :headers="headers"
        item-key="Email_id"
        @click:row="gotoaudience"
      >
        <template v-slot:top>
          <v-row>
            <v-flex xs6 sm6 lg6>
              <v-text-field
                v-model="audiencesearch"
                prepend-icon="mdi-magnify"
                clearable
              ></v-text-field>
            </v-flex>
            <v-flex xs1 sm1 lg1></v-flex>
            <v-flex xs4 sm4 lg4 align-self-center>
                            <div class="text-center d-flex align-center justify-space-around">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="refreshlist"
                      medium
                      color="green darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-refresh
                    </v-icon>
                  </template>
                  <span>Refresh </span>
                </v-tooltip>
              <v-dialog v-model="filterdialog" max-width="600px" persistent>
                  <template v-slot:activator="{ on: dialog }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on: tooltip }">
                        <v-icon v-bind="attrs" v-on="{ ...tooltip, ...dialog }">
                          mdi-filter-menu</v-icon
                        >
                      </template>
                      <span>Filters</span>
                    </v-tooltip>
                  </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">Audience Search Filters</span>
                  </v-card-title>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="companyfield"
                          prepend-icon="mdi-filter-variant"
                          label="Company Filter"
                          clearable
                        ></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="sortbyfield"
                          :items="sortbyfields"
                          label="Sort By"
                          multiple
                          outlined
                          dense
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <v-combobox
                          v-model="statusfield"
                          :items="statusfields"
                          label="Filter Status"
                          multiple
                          outlined
                          dense
                          clearable
                        ></v-combobox>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="refreshlist">
                      Done
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
                            </div>
            </v-flex>
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {
      loadformfields: true,
      PageTitle: "Search " + localStorage.getItem("CURPROFILE") + " Audiences",
      audiencesearch: "",
      audiences: [],
      sortbyfields: [],
      statusfields: [],
      formfields: [],
      filterdialog: false,
    };
  },

  computed: {
    headers() {
      return [
        { text: "First Name", value: "FirstName" },
        { text: "Last Name", value: "LastName" },
        { text: "email", value: "email" },
        { text: "Status", value: "mc-status" },
        { text: "Company Name", value: "Company_Name" },
      ];
    },
  },

  created() {
    this.refreshlist();
  },

  methods: {
    async refreshlist() {
      this.filterdialog = false;
      this.audiences = [];
      this.progressBar = true;
      this.myJsonResp = await this.PostData(
        "AudiencesList",
        JSON.stringify({
          curprofile: localStorage.getItem("CURPROFILE"),
          loadformfields: this.loadformfields,
          audiencesearch: this.audiencesearch,
          firstnamefield: this.firstnamefield,
          lastnamefield: this.lastnamefield,
          emailfield: this.emailfield,
          statusfield: this.statusfield,
          companyfield: this.companyfield,
          sortbyfield: this.sortbyfield,
        })
      );
      this.progressBar = false;
      if (this.myJsonResp != "ERROR") {
        this.loadformfields = false;
        this.data = JSON.parse(this.myJsonResp);
                this.PageTitle = "Search " + localStorage.getItem("CURPROFILE") + " Audiences - " + this.data["ResultCount"] + " Results "; 

        this.audiences = this.data["AUDIENCES"];
        this.formfields = JSON.parse(this.data["FORMFIELDS"]);
        this.statusfields = this.data["STATUSES"];
        this.sortbyfields = this.data["SORTBYFIELDS"];
        this.audiencesearch = this.formfields["audiencesearch"];
        this.firstnamefield = this.formfields["firstnamefield"];
        this.lastnamefield = this.formfields["lastnamefield"];
        this.emailfield = this.formfields["emailfield"];
        this.statusfield = this.formfields["statusfield"];
        this.companyfield = this.formfields["companyfield"];
        this.sortbyfield = this.formfields["sortbyfield"];
      }
    },

    gotoaudience(row) {
      this.$router.push("/Audience/" + row.Email_id + "/Company/" + row.Company_id); 
    },
  },
};
</script>